export default __webpack_public_path__ + "static/media/webmaster.31e06963.pdf";